// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"8d939771","57":"9e664dc7","124":"ac47fb88","227":"b3fc255e","353":"cb2c19b0","449":"13092c92","453":"87e45203","660":"dff304d2","697":"2d495c65","819":"d3b2aee9"}[chunkId] + ".chunk.js";
};